import {
  Injectable
} from '@angular/core';
import {
  Observable
} from 'rxjs';
import { BaseOptimizeService } from '~shared/services/base-optimize.service';
import { select, Store } from '@ngrx/store';
import { getActiveUrl, RouterState } from '~core/store';
import { filter, take } from 'rxjs/operators';
import { UrlUtils } from '~app/modules/generic/utils/url.utils';

const key = 'isCategoryPageCategoryFilterListEnabled';

@Injectable({
  providedIn: 'root'
})
export class CategoryPageCategoryFilterListService {

  constructor(
    private store: Store<RouterState>,
    private baseOptimizeService: BaseOptimizeService
  ) {
    this.subscribeToActiveUrl();
  }

  subscribeToActiveUrl() {
    this.store.pipe(select(getActiveUrl))
      .pipe(
        filter(url => UrlUtils.isCategoryPage(url)),
        take(1)
      )
      .subscribe(_ => this.baseOptimizeService.register(key));
  }

  get isCategoryPageCategoryFilterListEnabledObservable$(): Observable<boolean> {
    return this.baseOptimizeService.get(key);
  }
}
